import React from 'react';
import { CheckIcon, FactoryIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Industrial Maintenance with confidence starting today'];
export function FinalCta() {
  return <section className="bg-slate-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-74" data-mp="1jbagoavp6c0b">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-75" data-mp="1ed8yds63igpw">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-slate-200" data-id="element-76" data-mp="1t2ojariy3rxo">
          <FactoryIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="1o3lgzeucnzte" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-78" data-mp="222uw0b6tknvs">
          Created by industrial maintenance education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-79" data-mp="n75nbv0pkj4p" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-slate-300/40 bg-slate-800 p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-80" data-mp="s4pc3ov18eaw">
          <p data-id="element-81" data-mp="x64yplcuysve">
            <b className="block text-sm uppercase leading-tight text-white" data-id="element-82" data-mp="122v9pu9t2y9y">{productShortName}</b>
            <span className="text-sm text-slate-300" data-id="element-83" data-mp="164gojl5whmms">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-84" data-mp="1b1qkzkrpiyk4">
            <p className="text-sm text-slate-300" data-id="element-85" data-mp="1ftqg8zwu13ad">
              <span className="mr-2 line-through" data-id="element-86" data-mp="1fwcwrp1pat4q">{priceBefore}</span>
              <b className="text-base text-white" data-id="element-87" data-mp="1ks1nr3znn1pf">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-88" data-mp="1pszdc1mzuy0y">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-200" data-id="element-89" data-mp="3qu5pe6n6hlok">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-90" data-mp="3lthngpxevkfk">
              <CheckIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-91" data-mp="3iefghab5jyz" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}